/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

export const DIRECTORY_VIEWER_STRINGS = {
  errorLoadingDirectoryContents: 'Error loading File Store contents. Please try again.',
};
